<template>
  <div class="full">
    <md-card>
      <md-card-header>
        <md-whiteframe md-tag="md-toolbar" md-elevation="2" class="md-medium">
          <div class="md-toolbar-container"></div>

          <div class="md-toolbar-container">
            <h2 class="md-title">Lista de Solicitações</h2>

            <md-button @click="exportTickets()" class="md-fab fab-export">
              <md-icon>cloud_download</md-icon>
              <md-tooltip md-direction="top">Exportar Tickets</md-tooltip>
            </md-button>

            <md-button @click="openFilter()" class="md-fab fab-filter" md-fab-trigger>
              <md-icon>filter_list</md-icon>
              <md-tooltip v-if="isOpenFilter" md-direction="top">Remover Filtro</md-tooltip>
              <md-tooltip v-else md-direction="top">Filtrar</md-tooltip>
            </md-button>

            <router-link :to="createTicketsPath">
              <md-button class="md-fab fab-new">
                <md-icon>add</md-icon>
                <md-tooltip md-direction="top">Criar Tickets</md-tooltip>
              </md-button>
            </router-link>
          </div>
        </md-whiteframe>
      </md-card-header>

      <md-card-content>
        <md-layout md-gutter="16" mdFlex="100" v-if="isOpenFilter">
          <md-layout mdFlex="22">
            <md-input-container>
              <label>Código</label>
              <md-input v-model="filter.ticketKey"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout mdFlex="22">
            <md-input-container>
              <label for="status">Status</label>
              <md-select name="status" id="status" v-model="filter.situation">
                <md-option
                  v-for="situation in situations"
                  :key="situation"
                  :value="situation"
                >{{situation}}</md-option>
              </md-select>
            </md-input-container>
          </md-layout>

          <md-layout mdFlex="22">
            <md-input-container>
              <label>Placa</label>
              <md-autocomplete
                v-model="filter.vehiclePlate"
                :fetch="findVehiclesByPlateFetch"
                :print-attribute="'plate'"
              ></md-autocomplete>
            </md-input-container>
          </md-layout>

          <md-layout mdFlex="23">
            <md-input-container>
              <label>Organização</label>
              <md-autocomplete
                v-model="filter.organizationName"
                :fetch="findOrganizationsByNameFetch"
                :print-attribute="'name'"
              ></md-autocomplete>
            </md-input-container>
          </md-layout>

          <md-layout class="date-picker" mdFlex="22">
            <md-input-container>
              <label>Data de Criação</label>
              <md-input :value="getDateRangeFormated(filter.created)"></md-input>
            </md-input-container>
            <date-picker v-model="filter.created" range></date-picker>
          </md-layout>

          <md-layout mdFlex="5">
            <md-button @click="applyFilter" class="md-icon-button md-primary button-top">
              <md-icon>search</md-icon>
            </md-button>
          </md-layout>

          <md-layout mdFlex="5">
            <md-button @click="clearFilter" class="md-icon-button md-primary button-top">
              <md-icon>clear</md-icon>
            </md-button>
          </md-layout>
        </md-layout>

        <md-layout md-gutter="16" mdFlex="100" class="scrolable grid">
          <md-layout mdFlex="100">
            <md-table>
              <md-table-header>
                <md-table-row>
                  <md-table-head>Código</md-table-head>
                  <md-table-head>Data</md-table-head>
                  <md-table-head>Placa</md-table-head>
                  <md-table-head>Status</md-table-head>
                  <md-table-head>Resolução</md-table-head>
                  <md-table-head>Data de Resolução</md-table-head>
                  <md-table-head>Tipo de Requisição</md-table-head>
                  <md-table-head>Solicitante</md-table-head>
                  <md-table-head></md-table-head>
                  <md-table-head></md-table-head>
                  <md-table-head></md-table-head>
                </md-table-row>
              </md-table-header>

              <md-table-body>
                <md-table-row v-for="ticket in tickets" :key="ticket.key">
                  <md-table-cell>{{ticket.key}}</md-table-cell>

                  <md-table-cell>{{ticket.fields.created}}</md-table-cell>

                  <md-table-cell
                    v-if="ticket.fields.customfield_10401"
                  >{{ticket.fields.customfield_10401[0]}}</md-table-cell>
                  <md-table-cell v-else>Não disponível</md-table-cell>

                  <md-table-cell>{{ticket.fields.status.name}}</md-table-cell>

                  <md-table-cell v-if="ticket.fields.resolution">{{ticket.fields.resolution.name}}</md-table-cell>
                  <md-table-cell v-else>Não disponível</md-table-cell>

                  <md-table-cell
                    v-if="ticket.fields.resolutiondate"
                  >{{ticket.fields.resolutiondate}}</md-table-cell>
                  <md-table-cell v-else>Não disponível</md-table-cell>

                  <md-table-cell
                    v-if="ticket.fields.customfield_10700"
                  >{{ticket.fields.customfield_10700.value}}</md-table-cell>
                  <md-table-cell v-else>Não disponível</md-table-cell>

                  <md-table-cell v-if="ticket.fields.reporter">{{ticket.fields.reporter.name}}</md-table-cell>
                  <md-table-cell v-else>Não disponível</md-table-cell>

                  <md-table-cell>
                    <div>
                      <md-button @click="showTicket(ticket)" class="md-button md-primary">Ver</md-button>
                    </div>
                  </md-table-cell>

                  <md-table-cell>
                    <div>
                      <a
                        :href="'https://jira.trixlog.com/servicedesk/customer/portal/3/'+ticket.key"
                        target="_blank"
                        style="text-decoration: none"
                      >
                        <md-icon class="md-primary">edit</md-icon>
                      </a>
                    </div>
                  </md-table-cell>
                </md-table-row>

                <md-layout></md-layout>
              </md-table-body>
            </md-table>
          </md-layout>

          <md-layout mdAlign="center">
            <md-spinner v-if="isRequesting === true" :md-size="40" md-indeterminate></md-spinner>
          </md-layout>
          <md-layout mdAlign="center">
            <md-button @click="findTickets" class="md-accent md-raised">Carregar mais</md-button>
          </md-layout>
        </md-layout>

        <md-layout mdAlign="end">{{tickets.length}} de {{ticketsNumber}}</md-layout>
      </md-card-content>
    </md-card>

    <md-dialog ref="ticketDetails">
      <md-dialog-title>{{seenTicket.fields.summary}}</md-dialog-title>

      <md-dialog-content>
        <md-input-container>
          <label>Aberto em</label>
          <md-input readonly v-model="seenTicket.fields.created"></md-input>
        </md-input-container>
        <md-input-container v-if="seenTicket.fields.customfield_10401">
          <label>Placa</label>
          <md-input readonly v-model="seenTicket.fields.customfield_10401[0]"></md-input>
        </md-input-container>
        <md-input-container>
          <label>Status</label>
          <md-input readonly v-model="seenTicket.fields.status.name"></md-input>
        </md-input-container>
        <md-input-container>
          <label>Previsão de configuração</label>
          <md-input readonly v-model="linksStatus.configurationStatus"></md-input>
        </md-input-container>
        <md-input-container>
          <label>Previsão de expedição</label>
          <md-input readonly v-model="linksStatus.expeditionStatus"></md-input>
        </md-input-container>
        <md-input-container>
          <label>Descrição</label>
          <md-textarea readonly v-model="seenTicket.fields.description"></md-textarea>
        </md-input-container>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeShowTicketDialog()">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog md-open-from="#wait" md-close-to="#wait" ref="wait">
      <md-dialog-title>Aguarde ...</md-dialog-title>

      <md-dialog-content>
        <md-progress md-indeterminate></md-progress>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import ticketsService from "../services/TicketsService";
import moment from "moment/moment";
import router from "../router/index";
import AuthService from "../services/AuthService";
import loginInfoService from "../services/LoginInfoService";
import FileSaver from "file-saver";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

export default {
  components: {
    DatePicker
  },

  data() {
    return {
      tickets: [],
      seenTicket: {
        fields: {
          created: null,
          customfield_10401: [],
          description: null,
          status: {
            name: null
          },
          reporter: {
            name: null
          }
        }
      },
      linksStatus: {
        expeditionStatus: null,
        configurationStatus: null
      },
      isOpenFilter: false,
      situations: [],
      filter: {
        ticketKey: null,
        situation: null,
        organizationName: null,
        vehiclePlate: null,
        created: null,
        startAt: 0,
        maxResults: 50,
        fields: ["key","created","customfield_10401", "customfield_10700","customfield_10701","description","duedate","issuetype","reporter","resolution","resolutiondate","status","summary", "issuelinks"]
      },
      ticketsNumber: 0,
      startAt: 0,
      isRequesting: false,
      createTicketsPath: "/create_tickets"
    };
  },

  created() {
    var sessionId = this.$route.query["sessionid"];
    if (sessionId) {
      ticketsService.loginWithSessionId(sessionId).then(success => {
        var loginInfo = success.body;
        loginInfoService.setLoginInfo(loginInfo);

        AuthService.addToken(sessionId);
        this.findTickets(this.tickets.length);
        this.findTicketsSituations();
      });
    } else {
      var authorization = this.$route.query["authorization"];

      if (authorization) {
        ticketsService.loginWithAuthorization(authorization).then(success => {
          var loginInfo = success.body;
          loginInfoService.setLoginInfo(loginInfo);

          AuthService.addToken(authorization);
          this.findTickets(this.tickets.length);
          this.findTicketsSituations();
        });
      } else {
        this.findTickets(this.tickets.length);
        this.findTicketsSituations();
      }
    }

    this.setCreateTicketsUrl();
  },

  methods: {
    findTickets: function(startAt) {
      this.isRequesting = true;
      if (!Number.isInteger(startAt)) {
        startAt = this.startAt;
      }
      this.filter.startAt = startAt;
      this.filter.maxResults = 50;
      this.fields = ["key","created","customfield_10401", "customfield_10700","customfield_10701","description","duedate","issuetype","reporter","resolution","resolutiondate","status","summary", "issuelinks"]
      this.filter.start =
        this.filter.created &&
        this.filter.created[0] &&
        this.getDateFormated(this.filter.created[0]);
      this.filter.end =
        this.filter.created &&
        this.filter.created[1] &&
        this.getDateFormated(this.filter.created[1]);

      ticketsService.searchTickets(this.filter).then(success => {
        this.isRequesting = false;
        if (startAt === 0) {
          this.tickets = [];
        }
        var newTickets = success.body.issues;
        newTickets.forEach(issue => {
          issue.fields.created = this.getDateFormated(issue.fields.created);
          issue.fields.resolutiondate = this.getDateFormated(
            issue.fields.resolutiondate
          );
        });
        this.tickets = this.tickets.concat(newTickets);
        this.startAt = this.tickets.length;
        this.ticketsNumber = success.body.total;
      });
    },

    exportTickets: function() {
      this.openWaitDialog();

      let localFilter = Object.assign({}, this.filter);

      localFilter.fields = [
        "key",
        "customfield_10401",
        "status",
        "created",
        "resolution",
        "resolutiondate",
        "customfield_10700",
        "reporter",
        "summary"
      ];
      localFilter.csvParams = {
        defaultNull: "Indisponível",
        translationFieldsMapping: {
          key: "Código",
          "fields.customfield_10401": "Placa",
          "fields.status.name": "Status",
          "fields.created": "Criação",
          "fields.resolution.name": "Resolução",
          "fields.resolutiondate": "Data de Resolução",
          "fields.customfield_10700.value": "Tipo de Requisição",
          "fields.reporter.name": "Solicitante",
          "fields.summary": "Título"
        }
      };

      ticketsService.exportTickets(localFilter).then(success => {
        this.closeWaitDialog();
        FileSaver.saveAs(success.bodyText);
      });
    },

    findTicketsSituations: function() {
      ticketsService.findTicketsSituations().then(success => {
        this.situations = success.body;
      });
    },

    applyFilter: function(value) {
      this.findTickets(0);
    },

    openFilter: function() {
      this.isOpenFilter = !this.isOpenFilter;
      if (this.isOpenFilter === false) {
        this.filter.situation = null;
        this.findTickets(0);
      }
    },

    getDateRangeFormated(dates) {
      if (dates && dates[0] && dates[1]) {
        moment.locale("pt-br");
        return `${moment(dates[0]).format("L")} - ${moment(dates[1]).format(
          "L"
        )}`;
      }
      return null;
    },

    getDateFormated(date) {
      if (date) {
        moment.locale("pt-br");
        return moment(date).format("L");
      }
      return null;
    },

    showTicket: function(ticket) {
      this.seenTicket = ticket;

      this.openWaitDialog();

      var linksKeys = this.getTicketLinksKeys(ticket.fields.issuelinks);

      this.findDueDatesByTicketLinksKeys(linksKeys);
    },

    getTicketLinksKeys: function(issuelinks) {
      var links = issuelinks.map(function(link) {
        return link["outwardIssue"]["key"];
      });
      return links.join(",");
    },

    findDueDatesByTicketLinksKeys: function(linksKeys) {
      ticketsService.getDueDates(linksKeys).then(
        success => {
          this.closeWaitDialog();
          this.linksStatus = success.body;
          this.openShowTicketDialog();
        },
        error => {
          this.closeWaitDialog();
          this.linksStatus.expeditionStatus = "Sem previsão";
          this.linksStatus.configurationStatus = "Sem previsão";
          this.openShowTicketDialog();
        }
      );
    },

    openShowTicketDialog: function() {
      this.$refs.ticketDetails.open();
    },

    closeShowTicketDialog: function() {
      this.$refs.ticketDetails.close();
    },

    findVehiclesByPlateFetch: query => {
      return new Promise(resolve => {
        if (!query.q || query.q === "") {
          resolve([]);
        }
        ticketsService.findVehiclesByPlate(query.q).then(success => {
          resolve(success.body);
        });
      });
    },

    findOrganizationsByNameFetch: query => {
      return new Promise(resolve => {
        if (!query.q || query.q === "") {
          resolve([]);
        }
        ticketsService.searchOrganizations(query.q).then(success => {
          resolve(success.body);
        });
      });
    },

    clearFilter: function() {
      this.filter = {
        situation: null,
        organizationName: null,
        vehiclePlate: null,
        created: null,
        startAt: 0,
        maxResults: 50,
        fields: ["key","created","customfield_10401", "customfield_10700","customfield_10701","description","duedate","issuetype","reporter","resolution","resolutiondate","status","summary", "issuelinks"]
      };
      this.applyFilter(0);
    },

    setCreateTicketsUrl: function() {
      var loginInfo = loginInfoService.getLoginInfo();
      if (loginInfo.internal === true) {
        this.createTicketsPath = "/create_tickets_internal";
      }
    },

    openWaitDialog: function() {
      this.$refs.wait.open();
    },

    closeWaitDialog: function() {
      this.$refs.wait.close();
    }
  }
};
</script>

<style>
.scrolable {
  position: relative;
  max-height: 52vh;
  overflow: scroll;
}

.grid {
  display: inline-grid !important;
}

.md-dialog {
  width: 50% !important;
}

.fab-new {
  margin: 0;
  position: absolute !important;
  bottom: -28px;
  right: 16px;
}

.fab-filter {
  margin: 0;
  position: absolute !important;
  bottom: -28px;
  right: 80px;
}

.fab-export {
  margin: 0;
  position: absolute !important;
  bottom: -28px;
  right: 148px;
}

.md-table {
  overflow-x: unset !important;
}

.md-table .md-table-cell .md-button {
  width: auto !important;
}

.button-top {
  margin-top: 15px !important;
}

.mx-input-wrapper {
  position: absolute !important;
  top: -60px;
}

.mx-input-wrapper input {
  background: transparent;
  color: transparent;
  border: none;
}

.mx-input-wrapper i {
  display: none;
}

.date-picker {
  min-width: 200px;
}

.md-card-content {
  padding-top: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TicketsList.vue